var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotesRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 3C20.5375 3 22.9999 5.46243 22.9999 8.5C22.9999 10.7436 21.832 12.9144 20.0888 13.3333C19.4164 13.4949 18.8809 14.3578 18.996 15.3428C19.15 16.6613 20.3423 17.9934 22.7031 19.0431C23.2287 19.2769 23.0086 20.0676 22.4378 19.9961C16.2852 19.2258 12.0205 15.2148 12 9.53984C11.9999 5.63705 14.3057 3 17.4999 3Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49993 3C8.53749 3 10.9999 5.46243 10.9999 8.5C10.9999 10.7436 9.83198 12.9144 8.0888 13.3333C7.41639 13.4949 6.8809 14.3578 6.99596 15.3428C7.14997 16.6613 8.34229 17.9934 10.7031 19.0431C11.2287 19.2769 11.0086 20.0676 10.4378 19.9961C4.28525 19.2258 0.02046 15.2148 1.76622e-09 9.53984C-7.36882e-05 5.63705 2.30572 3 5.49993 3Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesRightGrey);
export default __webpack_public_path__ + "static/media/quotes-right-grey.f4351aa16c9ab180c71824dfc0ba99d4.svg";
export { ForwardRef as ReactComponent };